import React from 'react';
import { AgOrderInfo } from '@indigo-ag/schema';
import { MediumTitle } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { text } from 'shared';

interface BGCheckTypeProps {
  orderInfo: AgOrderInfo | undefined;
}

export const BackgroundCheckType: React.FunctionComponent<BGCheckTypeProps> = ({ orderInfo }) => {
  const opportunities = orderInfo?.opportunities || [];

  return (
    <MediumTitle>
      {`${text.firstLetterUppercase(i18next.t('backgroundCheckType'))}: ${(opportunities.length &&
        opportunities[0]?.backgroundCheckType) ||
        '-'}`}
    </MediumTitle>
  );
};
